import { Link } from "react-router-dom";
import { usePageContent } from "@/hooks/usePageContent";
import { useSiteStyles } from "@/hooks/useSiteStyles";
import { resolveImageUrl } from "@/utils/imageUrl";

const DEFAULT_LOGO = "https://customer-assets.emergentagent.com/job_realty-gallery/artifacts/zzc7uqc2_Screenshot_20260119_035617_Chrome.ico";

export const Footer = ({ showAdminLink = false }) => {
  const { get } = usePageContent("footer");
  const { styles } = useSiteStyles();
  const footerBg = { backgroundColor: styles.footerBgHex || "#2f4f4f" };
  const logoSrc = styles.companyLogo ? resolveImageUrl(styles.companyLogo) : DEFAULT_LOGO;
  const companyName = styles.navLogoText || "SellLocalHomes";

  return (
    <footer className="text-white" style={footerBg} data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-8">
        {/* Logo + Company Name */}
        <div className="mb-6">
          <Link to="/" className="flex items-center gap-3">
            <img src={logoSrc} alt={companyName} className="h-10 w-10 object-contain" />
            <span className="font-serif text-xl font-medium">{companyName}</span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
          {/* About */}
          <div className="space-y-3">
            <p className="text-white/70 text-xs leading-relaxed">
              {get("tagline", "Your trusted partner in selling your home. We connect sellers with exceptional marketing in prime locations.")}
            </p>
          </div>

          {/* Copyright + Legal Links */}
          <div className="space-y-3 text-right">
            <div className="flex flex-col gap-1 items-end">
              <Link to="/about" className="text-white/50 hover:text-white/70 text-xs transition-colors">About</Link>
              <Link to="/privacy" className="text-white/50 hover:text-white/70 text-xs transition-colors">Privacy Notice</Link>
              <Link to="/terms" className="text-white/50 hover:text-white/70 text-xs transition-colors">Terms & Conditions</Link>
            </div>
            <p className="text-white/50 text-xs">
              {get("copyright", `© ${new Date().getFullYear()} ${companyName}. All rights reserved.`)}
            </p>
            {showAdminLink && (
              <Link to="/admin" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-white/50 text-xs transition-colors" data-testid="footer-admin-link">
                Admin Dashboard
              </Link>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
